var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.44,
    height: 16.439,
    viewBox: "0 0 16.44 16.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-tags-3165375",
    d: "M115.511,52.29l.791-4.417a1.908,1.908,0,0,1,1.534-1.534l4.417-.791a1.717,1.717,0,0,1,1.527.466l7.643,7.643a1.785,1.785,0,0,1-.061,2.533L126.154,61.4a1.884,1.884,0,0,1-1.325.558,1.687,1.687,0,0,1-1.227-.5l-7.625-7.643a1.717,1.717,0,0,1-.466-1.527Zm3.681-.436a1.84,1.84,0,1,0,2.6-2.6,1.889,1.889,0,0,0-2.6,0,1.84,1.84,0,0,0,0,2.6Z",
    transform: "translate(-115.481 -45.518)",
    fill: "#6d44e5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.1ea6d1cefa76449696b337349a899ce6.svg";
export { ForwardRef as ReactComponent };